module.exports = __webpack_public_path__ + "static/img/1-480.445bb710.jpg";